import type { JSX } from 'react';
import { JobPositionCandidatesTable } from './JobPositionCandidatesTable';
import { JobPositionCandidateCard } from './JobPositionCandidateCard';
import type { SortState } from '@/shared/types/table-filters.types';
import type {
  ApplicationStatus,
  JobPositionCandidateWithDetails,
} from '../../types/jobPositionCandidate.types';

export interface JobPositionCandidateHandlers {
  onStatusChange: (candidateId: string, status: ApplicationStatus) => void;
  onUnlink: (candidateId: string, candidateName: string) => void;
  isUpdating: boolean;
}

export interface JobPositionCandidateRowsProps {
  candidates: JobPositionCandidateWithDetails[];
  sort: SortState | null;
  onToggleSort: (key: string) => void;
  itemHandlers: JobPositionCandidateHandlers;
}

/** Desktop table and mobile cards render the same already filtered/sorted candidates. */
export function JobPositionCandidateRows({
  candidates,
  sort,
  onToggleSort,
  itemHandlers,
}: JobPositionCandidateRowsProps): JSX.Element {
  if (candidates.length === 0) {
    return (
      <div className="flex items-center justify-center p-8">
        <p className="text-muted-foreground">No candidates match the filters.</p>
      </div>
    );
  }

  return (
    <>
      <div className="hidden md:block">
        <JobPositionCandidatesTable
          candidates={candidates}
          sort={sort}
          onToggleSort={onToggleSort}
          {...itemHandlers}
        />
      </div>
      <div className="grid gap-4 md:hidden">
        {candidates.map((candidate) => (
          <JobPositionCandidateCard key={candidate.id} candidate={candidate} {...itemHandlers} />
        ))}
      </div>
    </>
  );
}
